import { StyleSheet, } from '@react-pdf/renderer';

export const stylesDefensoresLotacao = StyleSheet.create(
  {
    page: {
      padding: 20,
      fontSize: 9,
      flexDirection: 'column',
      fontFamily: 'Helvetica',
    },
    title: {
      fontSize: 14,
      textAlign: 'center',
      marginBottom: 8,
      fontWeight: 'bold',
    },
    updated: {
      fontSize: 9,
      textAlign: 'center',
      marginBottom: 10,
      fontStyle: 'italic',
    },
    table: {
      flexDirection: 'column',
      width: '100%',
      marginBottom: 15,
    },
    tableRow: {
      flexDirection: 'row',
    },
    tableRowOdd: {
      backgroundColor: '#f5f5f5',
    },
    tableRowEven: {
      backgroundColor: '#ffffff',
    },
    tableColNome: {
      width: '30%',
      padding: 4,
    },
    tableColAtuacoes: {
      width: '70%',
      padding: 4,
    },
    tableCellHeader: {
      fontWeight: 'bold',
      backgroundColor: '#e0e6ed',
      textAlign: 'center',
    },
    textLine: {
      marginBottom: 2,
      flexWrap: 'wrap',
    },
    small: {
      fontSize: 8,
    },
    muted: {
      color: 'gray',
      fontSize: 8,
    },
    footer: {
      fontSize: 9,
      textAlign: 'right',
      marginTop: 10,
      fontStyle: 'italic',
    },
  });